export class ItemListItemDimensionsFactory {
    static create(itemListItemDimensions: IItemListItemDimensions): IContentAPIItemListItemDimensions {
        return new ItemListItemDimensions(itemListItemDimensions).serialize();
    }
}

export class ItemListItemDimensions {
    protected _width?: number;
    protected _height?: number;
    protected _depth?: number;
    protected _measurementUnit?: MeasurementUnit

    constructor(itemListItemDimensions: IItemListItemDimensions) {
        this._width = itemListItemDimensions.width;
        this._height = itemListItemDimensions.height;
        this._depth = itemListItemDimensions.depth;
        this._measurementUnit = itemListItemDimensions.measurementUnit;
    }

    serialize(): IContentAPIItemListItemDimensions {
        return {
            width: this._width,
            height: this._height,
            depth: this._depth,
            unit: this._measurementUnit,
            measurementUnit: this._measurementUnit
        };
    }
}

export interface IContentAPIItemListItemDimensions {
    width?: number;
    height?: number;
    depth?: number;
    /** @deprecated use `measurementUnit` instead. */
    unit?: string;
    measurementUnit?: MeasurementUnit;
}